var AccountAddress = (function ($) {

    var initButton = function () {
        initButtonsForDeliveryAddressTab();
        initButtonsForBillingAddressTab();
    };

    var initButtonsForDeliveryAddressTab = function () {
        $('.j-edit-address-form').on("click", function () {
            var addressId = $(this).data("address-id");
            $("#group-" + addressId).hide();
            $("#" + addressId).show();
        });

        $('.j-edit-address-delete').on("click", function (e) {
            var addressId = $(this).data("address-id");
            e.preventDefault();
            deleteAddress(addressId);
        });

        $(".j-edit-address-save").on("click", function (e) {
            var addressId = $(this).data("address-id");
            e.preventDefault();
            var deliveryAddressForm = $(this).closest(".j-submit-delivery-address-form");
            deliveryAddressForm.find(".form-fields-row [data-validation-required='1']")
                .trigger("validate-before-continue");

            if (deliveryAddressForm.find(".errorMessageRow").length === 0) {
                updateAddress(addressId);
            }
        });

        $('.j-edit-address-cancel').on("click", function () {
            $(document).trigger("reloadMyAccountDeliveryAddressesEvent");
        });

        $('.j-address-new').on("click", function () {
            $("#new-address-form").show();
            $("html, body").animate({scrollTop: 0}, "fast");
        });

        $(".j-edit-address-create").on("click", function (e) {
            e.preventDefault();
            var newDeliveryAddress = $("#new-address-form");
            newDeliveryAddress.find(".form-fields-row [data-validation-required='1']")
                .trigger("validate-before-continue");

            if (newDeliveryAddress.find(".errorMessageRow").length === 0) {
                createAddress();
            }
        });
    };

    var initButtonsForBillingAddressTab = function () {

        $('.j-edit-billing-address-form').on("click", function () {
            $("#group-billing").hide();
            $("#billing-address-form").show();
        });

        $('.j-edit-billing-address-cancel').on("click", function () {
            $(document).trigger("reloadMyAccountBillingAddressEvent");

        });

        $(".j-edit-billing-address-save").on("click", function (e) {
            e.preventDefault();
            var billingAddressForm = $("#billing-address-form");
            billingAddressForm.find(".form-fields-row [data-validation-required='1']")
                .trigger("validate-before-continue");

            if (billingAddressForm.find(".errorMessageRow").length === 0) {
                updateBillingAddress();
            }
        });
    };

    var deleteAddress = function (addressId) {
        var token = $("input[name='_csrf']").val();
        var header = "X-CSRF-TOKEN";
        $.ajax({
            url: "/my-account/delivery/" + addressId + "/delete",
            type: 'POST',
            beforeSend: function (xhr) {
                xhr.setRequestHeader(header, token);
            },
            success: function (response, textStatus, xhr) {
                $(document).trigger("reloadMyAccountDeliveryAddressesEvent");
            }
        });
    };

    var createAddress = function () {
        $( ".text-danger" ).remove();
        var token = $("input[name='_csrf']").val();
        var header = "X-CSRF-TOKEN";
        $.ajax({
            url: "/my-account/delivery/",
            type: 'POST',
            beforeSend: function (xhr) {
                xhr.setRequestHeader(header, token);
            },
            data: $("#new-address-form").serialize(),
            success: function (response) {
                if (response.status == 'SUCCESS') {
                    $(document).trigger("reloadMyAccountDeliveryAddressesEvent");
                } else {
                    displayErrors($("#new-form-panel-danger"), response, "new-address-form");
                }
            }
        });
    };

    var displayErrors = function (panel, response, formId) {
        $("input[data-validation-state='invalid_no_error']").each(function () {
            ($(this)).attr("data-validation-state", "valid");
        });
        if (response.generalErrors != null) {
            panel.empty();
            for (i = 0; i < response.generalErrors.length; i++) {
                panel.append("<div class='text error text-danger'>" + response.generalErrors[i] + "</div>");
            }
            panel.show();
        }
        if (response.fieldErrors != null) {
            $.each(response.fieldErrors, function (key, value) {
                ($("#" + formId + " input[data-form-name=" + key + "]")).attr("data-validation-state", "invalid_no_error");
                ($("#" + formId + " input[data-form-name=" + key + "]")).parent().append(("<div class='text error text-danger'>" + value + "</div>"));
                ($("#" + formId + " input[data-form-name=" + key + "]")).parent().attr("data-validation-state", "invalid_no_error");
            });
        }

    };

    var updateAddress = function (addressId) {
        $( ".text-danger" ).remove();
        var token = $("input[name='_csrf']").val();
        var header = "X-CSRF-TOKEN";
        $.ajax({
            url: "/my-account/delivery/" + addressId,
            type: 'POST',
            data: $("#" + addressId).serialize(),
            beforeSend: function (xhr) {
                xhr.setRequestHeader(header, token);
            },
            success: function (response) {
                if (response.status == 'SUCCESS') {
                    $(document).trigger("reloadMyAccountDeliveryAddressesEvent");
                } else {
                    displayErrors($("#address-panel-danger-" + addressId), response, addressId);
                }
            }
        });
    };

    var handleReloadMyAccountDeliveryAddressesEvent = function () {
        $(document).on("reloadMyAccountDeliveryAddressesEvent", function (event) {
            $.ajax({
                url: "/my-account/delivery/addresses",
                type: "GET",
                cache: false,
                success: function (myAccountDeliveryAddressesData) {
                    var $myAccountDeliveryAddressesData = $("#delivery-address-container");
                    $myAccountDeliveryAddressesData.empty();
                    $myAccountDeliveryAddressesData.html(myAccountDeliveryAddressesData);
                    window.THEME.$document.trigger("addFrontEndFormValidation", [$myAccountDeliveryAddressesData]);
                    window.THEME.$document.trigger("initSelect2forCountyTownPostalCodeInputs");
                    initButtonsForDeliveryAddressTab();
                }
            });
        });
    };

    var updateBillingAddress = function () {
        $( ".text-danger" ).remove();
        var token = $("input[name='_csrf']").val();
        var header = "X-CSRF-TOKEN";
        $.ajax({
            url: "/my-account/billing/form",
            type: 'POST',
            data: $("#billing-address-form").serialize(),
            beforeSend: function (xhr) {
                xhr.setRequestHeader(header, token);
            },
            success: function (response) {
                if (response.status == 'SUCCESS') {
                    $(document).trigger("reloadMyAccountBillingAddressEvent");
                } else {
                    displayErrors($("#address-panel-danger"), response, "billing-address-form");
                }
            }
        });
    };

    var handleReloadMyAccountBillingAddressEvent = function () {
        $(document).on("reloadMyAccountBillingAddressEvent", function (event) {
            $.ajax({
                url: "/my-account/billing/address",
                type: "GET",
                cache: false,
                success: function (myAccountBillingFormData) {
                    var $myAccountBillingFormData = $("#billing-address-container");
                    $myAccountBillingFormData.empty();
                    $myAccountBillingFormData.html(myAccountBillingFormData);
                    window.THEME.$document.trigger("addFrontEndFormValidation", [$myAccountBillingFormData]);
                    window.THEME.$document.trigger("initSelect2forCountyTownPostalCodeInputs");
                    initButtonsForBillingAddressTab();
                }
            });
        });
    };

    return {
        initButton: initButton,
        handleReloadMyAccountBillingAddressEvent: handleReloadMyAccountBillingAddressEvent,
        handleReloadMyAccountDeliveryAddressesEvent: handleReloadMyAccountDeliveryAddressesEvent
    };
})(jQuery);

$(document).ready(function () {
    $(".j-submit-form" ).change(function() {
        $( ".text-danger" ).remove();
    });
    AccountAddress.initButton();
    AccountAddress.handleReloadMyAccountBillingAddressEvent();
    AccountAddress.handleReloadMyAccountDeliveryAddressesEvent();
});